export default __webpack_public_path__ + "static/media/landing_img.4c3978d3.jpg";